/**
 * Villy Shop header: <vs-announcement>, <vs-header> (header bar, menu, search).
 * Depends on vs-core.js (window.VillyShop). No libraries. Every element tolerates being connected twice
 * (theme editor) and cleans up its timers and listeners in disconnectedCallback.
 */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var VS = function () { return window.VillyShop || {}; };
  var reduce = function () { return !!(VS().reduceMotion && VS().reduceMotion.matches); };
  var mq = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false, addEventListener: function () {}, removeEventListener: function () {} }; };
  var isPhone = function () { return mq('(max-width: 749px)').matches; };
  var isDesktopSearch = function () { return mq('(min-width: 990px)').matches; };

  function setVar(name, value) { root.style.setProperty(name, value); }

  /* the part of the announcement bar that is still on screen, in px */
  function barVisible() {
    var ann = doc.querySelector('.vs-ann');
    if (!ann || ann.hidden) return 0;
    var r = ann.getBoundingClientRect();
    return Math.max(0, Math.min(r.bottom, r.height));
  }
  function publishBar() { setVar('--vs-bar-h', Math.round(barVisible()) + 'px'); }

  /* ====================================================================== announcement */
  class VsAnnouncement extends HTMLElement {
    connectedCallback() {
      if (this.__ready) return;
      this.__ready = true;
      this.track = this.querySelector('.vs-ann__track');
      this.view = this.querySelector('.vs-ann__view');
      if (!this.track) return;

      var closed = VS().store ? VS().store('session', 'vs-ann-closed') === '1' : false;
      if (closed && this.getAttribute('data-allow-close') === 'true' && !(window.Shopify && window.Shopify.designMode)) {
        this.hidden = true;
        publishBar();
        return;
      }

      this.idx = 0;
      this.real = Array.prototype.slice.call(this.track.children);
      this.speed = 1000;
      if (this.real.length > 1) {
        this.clone = this.real[0].cloneNode(true);
        this.clone.setAttribute('aria-hidden', 'true');
        this.clone.removeAttribute('data-shopify-editor-block');
        this.clone.setAttribute('data-vs-clone', '');
        Array.prototype.forEach.call(this.clone.querySelectorAll('a, button'), function (a) { a.setAttribute('tabindex', '-1'); });
        this.track.appendChild(this.clone);
      }
      this.onResize = this.measure.bind(this);
      if (window.ResizeObserver) { this.ro = new ResizeObserver(this.onResize); this.ro.observe(this); }
      window.addEventListener('resize', this.onResize);
      this.onScroll = function () { publishBar(); };
      window.addEventListener('scroll', this.onScroll, { passive: true });

      var close = this.querySelector('[data-vs-ann-close]');
      if (close) close.addEventListener('click', this.close.bind(this));

      this.paused = false;
      this.addEventListener('mouseenter', this.pause.bind(this, true));
      this.addEventListener('mouseleave', this.pause.bind(this, false));
      this.addEventListener('focusin', this.pause.bind(this, true));
      this.addEventListener('focusout', this.pause.bind(this, false));
      this.addEventListener('touchstart', this.pause.bind(this, true), { passive: true });
      this.addEventListener('touchend', this.pause.bind(this, false), { passive: true });
      this.onVis = this.sync.bind(this);
      doc.addEventListener('visibilitychange', this.onVis);
      this.addEventListener('vs:countdown-end', this.dropEnded.bind(this));
      var self = this;
      this.onSelect = function (e) {
        var id = e.detail && e.detail.blockId;
        var idx = self.real.findIndex(function (s) { return s.getAttribute('data-vs-block') === id; });
        if (idx > -1) { self.editing = true; window.clearTimeout(self.timer); self.setIndex(idx, false); }
      };
      this.onDeselect = function () { self.editing = false; self.sync(); };
      doc.addEventListener('shopify:block:select', this.onSelect);
      doc.addEventListener('shopify:block:deselect', this.onDeselect);
      this.measure();
      this.mark();
      this.sync();
      publishBar();
    }
    disconnectedCallback() {
      this.__ready = false;
      window.clearTimeout(this.timer);
      if (this.ro) this.ro.disconnect();
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('scroll', this.onScroll);
      doc.removeEventListener('visibilitychange', this.onVis);
      doc.removeEventListener('shopify:block:select', this.onSelect);
      doc.removeEventListener('shopify:block:deselect', this.onDeselect);
    }
    slides() { return Array.prototype.slice.call(this.track.children); }
    measure() {
      var h = 56;
      this.slides().forEach(function (s) {
        var m = s.querySelector('.vs-ann__msg');
        if (m) h = Math.max(h, m.offsetHeight);
      });
      this.style.setProperty('--vs-ann-h', h + 'px');
      this.h = h;
      this.setIndex(this.idx, true);
      publishBar();
    }
    setIndex(i, instant) {
      this.idx = i;
      if (instant) this.track.classList.add('is-jump');
      this.track.style.transform = 'translateY(' + (-i * (this.h || 56)) + 'px)';
      if (instant) { void this.track.offsetHeight; this.track.classList.remove('is-jump'); }
      this.mark();
    }
    mark() {
      var idx = this.idx;
      this.slides().forEach(function (s, n) {
        var visible = n === idx;
        s.setAttribute('aria-hidden', visible ? 'false' : 'true');
        Array.prototype.forEach.call(s.querySelectorAll('a'), function (a) { if (visible) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); });
      });
    }
    pause(on) { this.paused = on; this.sync(); }
    sync() {
      window.clearTimeout(this.timer);
      var play = this.getAttribute('data-autoplay') === 'true' && this.real.length > 1 && !this.paused && !this.editing && !doc.hidden && !reduce();
      if (!play) return;
      var delay = (parseFloat(this.getAttribute('data-delay')) || 3) * 1000 + this.speed;
      var self = this;
      this.timer = window.setTimeout(function () { self.advance(); }, delay);
    }
    advance() {
      var self = this;
      var next = this.idx + 1;
      this.setIndex(next, false);
      window.setTimeout(function () {
        if (self.idx >= self.real.length) self.setIndex(0, true);
        self.sync();
      }, this.speed + 40);
    }
    close() {
      var self = this;
      if (VS().store) VS().store('session', 'vs-ann-closed', '1');
      window.clearTimeout(this.timer);
      this.style.height = this.offsetHeight + 'px';
      void this.offsetHeight;
      this.classList.add('is-closed');
      this.style.height = '0px';
      window.setTimeout(function () { self.hidden = true; publishBar(); }, 320);
      this.dispatchEvent(new CustomEvent('vs:ann-change', { bubbles: true }));
    }
    dropEnded(event) {
      var slide = event.target.closest('.vs-ann__slide');
      if (!slide) return;
      var key = slide.getAttribute('data-vs-block');
      this.slides().forEach(function (s) { if (s.getAttribute('data-vs-block') === key) s.remove(); });
      this.real = this.slides().filter(function (s) { return !s.hasAttribute('data-vs-clone'); });
      if (!this.real.length) { this.hidden = true; publishBar(); return; }
      if (this.real.length === 1) this.slides().forEach(function (s) { if (s.hasAttribute('data-vs-clone')) s.remove(); });
      this.idx = 0;
      this.measure();
      this.sync();
    }
  }
  if (!customElements.get('vs-announcement')) customElements.define('vs-announcement', VsAnnouncement);

  /* ====================================================================== menu */
  function Menu(host) {
    this.host = host;
    this.dlg = host.querySelector('[data-vs-menu]');
    this.opener = host.querySelector('[data-vs-open-menu]');
    this.card = this.dlg.querySelector('.vs-menu__card');
    this.path = ['root'];
    this.timers = [];
    this.bind();
  }
  Menu.prototype.el = function (id) { return this.dlg.querySelector('[data-level-id="' + id + '"]') || this.dlg.querySelector('#vs-L-' + id); };
  Menu.prototype.bind = function () {
    var self = this;
    this.opener.addEventListener('click', function () { self.open('root'); });
    this.dlg.addEventListener('click', function (event) {
      var t = event.target;
      if (t.closest('[data-vs-close]')) { VS().closeDialog(self.dlg); return; }
      var go = t.closest('[data-vs-go]');
      if (go) { event.preventDefault(); self.go(go.getAttribute('data-vs-go'), go); return; }
      var back = t.closest('[data-vs-back]');
      if (back) { event.preventDefault(); self.back(back.getAttribute('data-vs-back')); return; }
      var link = t.closest('a[href]');
      if (link && link.getAttribute('href') !== '#') { VS().closeDialog(self.dlg, true); return; }
      if (t.hasAttribute('data-vs-close-overlay')) VS().closeDialog(self.dlg);
    });
    this.dlg.addEventListener('vs:close', function () { self.reset(); });
  };
  Menu.prototype.setTop = function () {
    var gap = isPhone() ? 8 : 16;
    this.dlg.style.setProperty('--vs-menu-top', Math.round(Math.max(gap, barVisible() + gap)) + 'px');
  };
  Menu.prototype.indexRows = function (level) {
    var i = 0;
    Array.prototype.forEach.call(level.querySelectorAll('[data-vs-row]'), function (row) {
      row.style.setProperty('--i', String(Math.min(i, 14)));
      i += 1;
    });
  };
  Menu.prototype.activate = function (level) {
    if (!level) return;
    level.classList.remove('is-leaving');
    level.classList.add('is-on');
    this.indexRows(level);
    void level.offsetWidth;
    level.classList.add('is-active');
    level.removeAttribute('inert');
  };
  Menu.prototype.deactivate = function (level, instant) {
    if (!level) return;
    level.classList.remove('is-active');
    level.setAttribute('inert', '');
    if (instant || reduce()) { level.classList.remove('is-on', 'is-leaving'); return; }
    level.classList.add('is-leaving');
    window.setTimeout(function () { if (!level.classList.contains('is-active')) level.classList.remove('is-on', 'is-leaving'); }, 160);
  };
  Menu.prototype.later = function (fn, ms) {
    var t = window.setTimeout(fn, ms);
    this.timers.push(t);
  };
  Menu.prototype.showPushes = function (entryId) {
    Array.prototype.forEach.call(this.dlg.querySelectorAll('.vs-pushcol'), function (col) {
      var on = entryId && col.getAttribute('data-for') === entryId;
      if (on) {
        col.hidden = false;
        window.requestAnimationFrame(function () { col.classList.add('is-shown'); });
      } else {
        col.classList.remove('is-shown');
        col.hidden = true;
      }
    });
  };
  Menu.prototype.setState = function () {
    var depth = this.path.length;
    this.card.setAttribute('data-depth', String(depth));
    this.card.setAttribute('data-level', this.path[this.path.length - 1]);
  };
  Menu.prototype.markOpen = function (btn, on) {
    if (!btn) return;
    btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    var li = btn.closest('li');
    var list = btn.closest('.vs-list');
    if (li) li.classList.toggle('is-open', on);
    if (list) list.classList.toggle('has-open', !!list.querySelector(':scope > li.is-open'));
  };
  Menu.prototype.go = function (id, trigger) {
    var self = this;
    var target = this.el(id);
    if (!target) return;
    var parentId = target.getAttribute('data-parent');
    var phone = isPhone();
    var entryId;
    if (parentId === 'root') {
      var from = this.el(this.path[this.path.length - 1]);
      Array.prototype.forEach.call(this.dlg.querySelectorAll('.vs-level--3.is-on'), function (l) { self.deactivate(l, true); });
      this.path = ['root', id];
      entryId = id;
      this.markOpen(this.dlg.querySelector('#vs-L-root [data-vs-go="' + id + '"]'), true);
      this.deactivate(this.el('root'));
      this.setState();
      this.showPushes(id);
      this.later(function () {
        self.activate(target);
        var crumb = target.querySelector('.vs-crumb');
        if (crumb) crumb.focus({ preventScroll: true });
      }, reduce() ? 0 : 160);
    } else {
      entryId = parentId;
      var level2 = this.el(parentId);
      Array.prototype.forEach.call(this.dlg.querySelectorAll('.vs-level--3.is-on'), function (l) { if (l !== target) self.deactivate(l, true); });
      Array.prototype.forEach.call(level2.querySelectorAll('[data-vs-go]'), function (b) { self.markOpen(b, b === trigger); });
      this.path = ['root', parentId, id];
      this.setState();
      this.showPushes(phone ? parentId : parentId);
      if (phone) {
        this.deactivate(level2);
        this.later(function () {
          self.activate(target);
          var crumb = target.querySelector('.vs-crumb');
          if (crumb) crumb.focus({ preventScroll: true });
        }, reduce() ? 0 : 160);
      } else {
        this.alignColumn(level2);
        this.activate(target);
        var first = target.querySelector('a, button');
        if (first && trigger && trigger.matches(':focus-visible')) first.focus({ preventScroll: true });
      }
    }
  };
  /* desktop: the rows of level 3 start level with the first row of level 2 */
  Menu.prototype.alignColumn = function (level2) {
    var col = this.dlg.querySelector('.vs-menu__col--2');
    var first = level2 && level2.querySelector('.vs-list .vs-row');
    if (!col || !first) return;
    var d = first.getBoundingClientRect().top - col.getBoundingClientRect().top;
    if (d > 0) col.style.paddingTop = Math.round(d) + 'px';
  };
  Menu.prototype.back = function (toId) {
    var self = this;
    var current = this.path[this.path.length - 1];
    var cur = this.el(current);
    var phone = isPhone();
    if (toId === 'root') {
      var entry = this.path[1];
      Array.prototype.forEach.call(this.dlg.querySelectorAll('.vs-level--3.is-on'), function (l) { self.deactivate(l, true); });
      this.deactivate(this.el(entry));
      this.path = ['root'];
      this.setState();
      this.showPushes(null);
      var rootLevel = this.el('root');
      Array.prototype.forEach.call(rootLevel.querySelectorAll('[data-vs-go]'), function (b) { self.markOpen(b, false); });
      this.later(function () {
        self.activate(rootLevel);
        var btn = rootLevel.querySelector('[data-vs-go="' + entry + '"]');
        if (btn) btn.focus({ preventScroll: true });
      }, reduce() ? 0 : 160);
    } else {
      // from level 3 back to level 2
      this.deactivate(cur, true);
      this.path = ['root', toId];
      this.setState();
      var l2 = this.el(toId);
      Array.prototype.forEach.call(l2.querySelectorAll('[data-vs-go]'), function (b) { self.markOpen(b, false); });
      if (phone) this.later(function () { self.activate(l2); var b = l2.querySelector('[data-vs-go="' + current + '"]'); if (b) b.focus({ preventScroll: true }); }, reduce() ? 0 : 160);
    }
  };
  Menu.prototype.reset = function () {
    var self = this;
    this.timers.forEach(function (t) { window.clearTimeout(t); });
    this.timers = [];
    Array.prototype.forEach.call(this.dlg.querySelectorAll('.vs-level'), function (l) { self.deactivate(l, true); });
    Array.prototype.forEach.call(this.dlg.querySelectorAll('[data-vs-go]'), function (b) { self.markOpen(b, false); });
    this.path = ['root'];
    this.setState();
    this.showPushes(null);
    this.opener.setAttribute('aria-expanded', 'false');
    if (this.restoreFocus !== false) this.opener.focus({ preventScroll: true });
    this.restoreFocus = true;
  };
  Menu.prototype.open = function (levelId) {
    var self = this;
    if (!this.dlg.open) {
      this.setTop();
      this.dlg.classList.add('is-opening');
      this.opener.setAttribute('aria-expanded', 'true');
      var rootLevel = this.el('root');
      rootLevel.classList.add('is-on');
      this.indexRows(rootLevel);
      rootLevel.classList.add('is-active');
      rootLevel.removeAttribute('inert');
      VS().openDialog(this.dlg);
      var x = this.dlg.querySelector('[data-vs-close]');
      if (x) x.focus({ preventScroll: true });
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () { self.dlg.classList.remove('is-opening'); });
        });
      });
    }
    if (levelId && levelId !== 'root') {
      var btn = this.dlg.querySelector('[data-vs-go="' + levelId + '"]');
      this.later(function () { self.go(levelId, btn); }, 60);
    }
  };
  Menu.prototype.closeNow = function () { this.restoreFocus = false; VS().closeDialog(this.dlg, true); };

  /* ====================================================================== search */
  function Search(host) {
    this.host = host;
    this.dlg = host.querySelector('[data-vs-search]');
    this.opener = host.querySelector('[data-vs-open-search]');
    this.input = this.dlg.querySelector('.vs-search__input');
    this.ph = this.dlg.querySelector('.vs-search__ph');
    this.clearBtn = this.dlg.querySelector('[data-vs-search-clear]');
    this.status = this.dlg.querySelector('[data-vs-search-status]');
    this.groups = {
      popular: this.dlg.querySelector('[data-vs-group="popular"]'),
      new: this.dlg.querySelector('[data-vs-group="new"]'),
      typed: this.dlg.querySelector('[data-vs-group="typed"]'),
    };
    this.terms = (this.dlg.getAttribute('data-terms') || '').split('|').map(function (t) { return t.trim(); }).filter(Boolean);
    this.template = this.dlg.getAttribute('data-placeholder') || 'Search for “{term}”';
    this.termIndex = 0;
    this.bind();
  }
  Search.prototype.phText = function () {
    if (!this.terms.length) return 'Search';
    return this.template.replace('{term}', this.terms[this.termIndex % this.terms.length]);
  };
  Search.prototype.bind = function () {
    var self = this;
    this.ph.textContent = this.phText();
    this.opener.addEventListener('click', function () { self.open(true); });
    this.opener.addEventListener('mouseenter', function () {
      if (isDesktopSearch() && mq('(hover: hover)').matches && !self.dlg.open) self.open(false);
    });
    this.dlg.addEventListener('mouseleave', function () {
      if (!isDesktopSearch() || self.input === doc.activeElement || self.input.value) return;
      self.leaveTimer = window.setTimeout(function () {
        if (self.input !== doc.activeElement && !self.input.value && !self.dlg.matches(':hover')) self.close(false);
      }, 350);
    });
    this.dlg.addEventListener('mouseenter', function () { window.clearTimeout(self.leaveTimer); });
    this.dlg.querySelector('[data-vs-search-close]').addEventListener('click', function () { self.close(true); });
    this.clearBtn.addEventListener('click', function () { self.input.value = ''; self.onInput(); self.input.focus(); });
    this.input.addEventListener('input', this.onInput.bind(this));
    this.input.addEventListener('focus', function () { self.stopRotation(); });
    this.dlg.addEventListener('keydown', this.onKey.bind(this));
    this.dlg.addEventListener('vs:close', function () { self.afterClose(); });
    this.dlg.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-vs-tab]');
      if (tab) self.tab(tab.getAttribute('data-vs-tab'));
      if (event.target.closest('a[href]')) VS().closeDialog(self.dlg, true);
    });
    this.outside = function (event) {
      if (!self.dlg.open || !isDesktopSearch() || self.dlg.__vsLocked) return;
      if (self.dlg.contains(event.target) || self.opener.contains(event.target)) return;
      self.close(false);
    };
    doc.addEventListener('pointerdown', this.outside);
    this.host.addEventListener('vs:search-destroy', function () { doc.removeEventListener('pointerdown', self.outside); });
  };
  Search.prototype.destroy = function () {
    doc.removeEventListener('pointerdown', this.outside);
    this.stopRotation();
    window.clearTimeout(this.debounce);
    window.clearTimeout(this.leaveTimer);
    if (this.abort) this.abort.abort();
    if (this.dlg.open) VS().closeDialog(this.dlg, true);
  };
  Search.prototype.open = function (focus) {
    var self = this;
    window.clearTimeout(this.leaveTimer);
    if (this.dlg.open) { if (focus) this.input.focus(); return; }
    var modeless = isDesktopSearch();
    if (modeless) this.dlg.setAttribute('data-vs-modeless', '');
    else this.dlg.removeAttribute('data-vs-modeless');
    VS().openDialog(this.dlg, { modeless: modeless });
    this.opener.setAttribute('aria-expanded', 'true');
    this.input.setAttribute('aria-expanded', 'true');
    if (focus || !modeless) window.requestAnimationFrame(function () { self.input.focus({ preventScroll: true }); });
    if (!this.input.value) this.startRotation();
  };
  Search.prototype.close = function (focusOpener) {
    this.focusOpener = focusOpener;
    VS().closeDialog(this.dlg);
  };
  Search.prototype.afterClose = function () {
    this.opener.setAttribute('aria-expanded', 'false');
    this.input.setAttribute('aria-expanded', 'false');
    this.stopRotation();
    this.input.value = '';
    this.onInput();
    this.tab('popular');
    if (this.focusOpener !== false) this.opener.focus({ preventScroll: true });
    this.focusOpener = true;
  };
  Search.prototype.tab = function (name) {
    var self = this;
    Array.prototype.forEach.call(this.dlg.querySelectorAll('[data-vs-tab]'), function (b) {
      var on = b.getAttribute('data-vs-tab') === name;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    this.groups.popular.hidden = name !== 'popular';
    this.groups.new.hidden = name !== 'new';
    this.groups.typed.hidden = true;
    void self;
  };
  Search.prototype.startRotation = function () {
    var self = this;
    this.stopRotation();
    if (this.terms.length < 2 || reduce()) return;
    this.rotator = window.setInterval(function () {
      if (self.input === doc.activeElement || self.input.value) return;
      self.ph.classList.add('is-swap');
      window.setTimeout(function () {
        self.termIndex += 1;
        self.ph.textContent = self.phText();
        self.ph.classList.remove('is-swap');
      }, 300);
    }, 3000);
  };
  Search.prototype.stopRotation = function () { window.clearInterval(this.rotator); };
  Search.prototype.onInput = function () {
    var q = this.input.value.trim();
    var has = this.input.value.length > 0;
    this.dlg.classList.toggle('has-text', has);
    this.dlg.classList.toggle('is-typing', q.length > 0);
    this.clearBtn.hidden = !has;
    this.stopRotation();
    window.clearTimeout(this.debounce);
    if (!q) {
      this.groups.typed.hidden = true;
      this.groups.typed.innerHTML = '';
      var popular = this.dlg.querySelector('[data-vs-tab].is-selected');
      this.tab(popular ? popular.getAttribute('data-vs-tab') : 'popular');
      if (!has && this.dlg.open) this.startRotation();
      return;
    }
    var self = this;
    this.debounce = window.setTimeout(function () { self.fetchResults(q); }, 180);
  };
  Search.prototype.money = function (value) {
    var cfg = window.VILLY_CONFIG || {};
    var n = parseFloat(value);
    if (isNaN(n)) return '';
    try { return new Intl.NumberFormat(cfg.locale || 'en-GB', { style: 'currency', currency: cfg.currency || 'GBP' }).format(n); } catch (e) { return String(n); }
  };
  Search.prototype.sized = function (url) {
    if (!url) return '';
    try { var u = new URL(url, location.href); u.searchParams.set('width', '108'); return u.toString(); } catch (e) { return url; }
  };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  Search.prototype.row = function (p) {
    var img = (p.featured_image && p.featured_image.url) || p.image || '';
    var type = p.product_type || p.type || '';
    return '<a class="vs-sugg" role="option" href="' + esc(p.url) + '">' +
      '<span class="vs-sugg__img">' + (img ? '<img class="vs-sugg__photo" alt="" loading="lazy" width="54" height="54" src="' + esc(this.sized(img)) + '">' : '') + '</span>' +
      '<span class="vs-sugg__body"><span class="vs-sugg__name">' + esc(p.title) + '</span>' +
      (type ? '<span class="vs-sugg__sub">' + esc(type) + '</span>' : '') +
      '<span class="vs-sugg__price">' + esc(this.money(p.price)) + '</span></span></a>';
  };
  Search.prototype.fetchResults = function (q) {
    var self = this;
    if (this.abort) this.abort.abort();
    this.abort = window.AbortController ? new AbortController() : null;
    var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    var url = base + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    var all = this.dlg.getAttribute('data-all') || 'See all results for “{q}”';
    var nothing = this.dlg.getAttribute('data-nothing') || 'Nothing found for “{q}”.';
    var more = '<a class="vs-search__more" href="' + esc(((this.dlg.querySelector('form') || {}).action || '/search') + '?q=' + encodeURIComponent(q)) + '">' + esc(all.replace('{q}', q)) + '</a>';
    fetch(url, { signal: this.abort ? this.abort.signal : undefined, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('search'); return r.json(); })
      .then(function (data) {
        if (self.input.value.trim() !== q) return;
        var list = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        var html = list.length ? list.map(function (p) { return self.row(p); }).join('') + more : '<p class="vs-search__empty">' + esc(nothing.replace('{q}', q)) + '</p>' + more;
        self.groups.typed.innerHTML = html;
        self.groups.popular.hidden = true; self.groups.new.hidden = true; self.groups.typed.hidden = false;
        if (self.status) self.status.textContent = list.length + (list.length === 1 ? ' result' : ' results');
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        self.groups.typed.innerHTML = more;
        self.groups.popular.hidden = true; self.groups.new.hidden = true; self.groups.typed.hidden = false;
      });
  };
  Search.prototype.visibleRows = function () {
    return Array.prototype.slice.call(this.dlg.querySelectorAll('.vs-search__group:not([hidden]) a'));
  };
  Search.prototype.onKey = function (event) {
    if (event.key === 'Escape') {
      if (!this.dlg.__vsLocked) { event.preventDefault(); this.close(true); }
      return;
    }
    var rows = this.visibleRows();
    var i = rows.indexOf(doc.activeElement);
    if (event.key === 'ArrowDown') {
      if (!rows.length) return;
      event.preventDefault();
      rows[Math.min(rows.length - 1, i + 1)].focus();
    } else if (event.key === 'ArrowUp' && i > -1) {
      event.preventDefault();
      if (i === 0) this.input.focus(); else rows[i - 1].focus();
    }
  };

  /* ====================================================================== header */
  class VsHeader extends HTMLElement {
    connectedCallback() {
      if (this.__ready) return;
      this.__ready = true;
      this.bar = this.querySelector('.vs-header__bar');
      this.menu = new Menu(this);
      this.search = new Search(this);
      this.lastY = window.scrollY;
      this.ticking = false;
      this.hidden_ = false;
      this.onScroll = this.scroll.bind(this);
      this.onResize = this.measure.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      if (window.ResizeObserver) { this.ro = new ResizeObserver(this.onResize); this.ro.observe(this.bar); }
      this.focusInside = false;
      this.addEventListener('focusin', function () { this.focusInside = true; this.show(); });
      this.addEventListener('focusout', function (e) { if (!this.contains(e.relatedTarget)) this.focusInside = false; });
      doc.addEventListener('vs:ann-change', this.onResize);
      this.onBlock = this.editorBlock.bind(this);
      doc.addEventListener('shopify:block:select', this.onBlock);
      this.onBlockOff = this.editorOff.bind(this);
      doc.addEventListener('shopify:block:deselect', this.onBlockOff);
      doc.addEventListener('shopify:section:deselect', this.onBlockOff);
      this.measure();
      this.overlay();
    }
    disconnectedCallback() {
      this.__ready = false;
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      doc.removeEventListener('vs:ann-change', this.onResize);
      doc.removeEventListener('shopify:block:select', this.onBlock);
      doc.removeEventListener('shopify:block:deselect', this.onBlockOff);
      doc.removeEventListener('shopify:section:deselect', this.onBlockOff);
      if (this.ro) this.ro.disconnect();
      if (this.search) this.search.destroy();
      if (this.menu && this.menu.dlg.open) this.menu.closeNow();
      root.classList.remove('vs-overlay-header');
      root.removeAttribute('data-vs-hdr-hidden');
    }
    measure() {
      var h = this.bar.offsetHeight || (isPhone() ? 72 : 80);
      setVar('--vs-header-h', h + 'px');
      setVar('--header-height', h + 'px');
      this.h = h;
      publishBar();
      this.stick();
    }
    stick() { setVar('--vs-stick', (this.hidden_ ? 0 : (this.h || 80)) + 'px'); }
    locked() {
      return this.focusInside || this.menu.dlg.open || (this.search.dlg.open && this.search.dlg.__vsLocked) ||
        (VS().anyDialogOpen && VS().anyDialogOpen()) || !!doc.querySelector('details[open].vs-keep-header');
    }
    scroll() {
      if (this.ticking) return;
      this.ticking = true;
      var self = this;
      window.requestAnimationFrame(function () {
        self.ticking = false;
        var y = Math.max(0, window.scrollY);
        var d = y - self.lastY;
        publishBar();
        if (y <= 0) self.show();
        else if (d > 6 && y > (self.h || 80) && !self.locked()) self.hide();
        else if (d < -6) self.show();
        if (Math.abs(d) > 6 || y <= 0) self.lastY = y;
        if (self.overlayOn) self.bar.parentElement.toggleAttribute('data-solid', y > 8);
      });
    }
    /* hidden = the bar fades out AND the whole header (host + sticky wrapper) stops taking clicks, so the listing toolbar and anything else
       that scrolls under the top band stays clickable. The flag lives on <html> because the wrapper (.section-header) sits outside this element. */
    hide() { if (this.hidden_) return; this.hidden_ = true; this.setAttribute('data-hidden', ''); root.setAttribute('data-vs-hdr-hidden', ''); this.stick(); }
    show() { if (!this.hidden_) return; this.hidden_ = false; this.removeAttribute('data-hidden'); root.removeAttribute('data-vs-hdr-hidden'); this.stick(); }
    overlay() {
      var on = this.getAttribute('data-overlay') === 'true';
      var hero = doc.querySelector('main [data-vs-hero="full"]');
      var first = doc.querySelector('main .shopify-section');
      this.overlayOn = on && !!hero && !!first && first.contains(hero);
      root.classList.toggle('vs-overlay-header', this.overlayOn);
      this.toggleAttribute('data-solid', this.overlayOn && window.scrollY > 8);
    }
    editorBlock(event) {
      if (!this.contains(event.target)) return;
      var id = event.detail && event.detail.blockId;
      if (id && this.querySelector('[data-vs-go="e' + id + '"]')) this.menu.open('e' + id);
    }
    editorOff() { if (this.menu.dlg.open) this.menu.closeNow(); }
  }
  if (!customElements.get('vs-header')) customElements.define('vs-header', VsHeader);

  /* a section edit in the theme editor replaces the markup: make sure nothing stays locked */
  doc.addEventListener('shopify:section:unload', function () {
    var lock = doc.querySelector('dialog.vs-dlg[open]');
    if (!lock) root.classList.remove('vs-no-scroll');
  });
})();
